'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { useTheme } from '@/utils/coins/useTheme';

const AdvancedRealTimeChart = dynamic(
    () => import('react-ts-tradingview-widgets').then((w) => w.AdvancedRealTimeChart),
    {
        ssr: false,
    },
);

interface TradingViewProps {
    symbol: string;
}

const TradingViewChart: React.FC<TradingViewProps> = ({ symbol }) => {
    const [theme] = useTheme('light'); // Use the custom hook for theme

    return (
        <div
            // Use a specific height, e.g., 500px, to match our previous style
            className='tradingview-widget-container h-[500px] w-full overflow-hidden'
            style={{ height: '400px' }}
        >
            <AdvancedRealTimeChart
                allow_symbol_change={true}
                theme={theme.toLowerCase() as 'light' | 'dark'}
                interval={'D'}
                symbol={symbol}
                autosize
            />
        </div>
    );
};

export default TradingViewChart;
